import { useCallback } from "react";
import { ENVIRONMENT } from "../../../env";

export const useDock = () => {
  const handleNoteClick = useCallback(() => {
    if (ENVIRONMENT === "DEV") console.log("Dock: note clicked");
  }, []);

  const handleAttachClick = useCallback(() => {
    if (ENVIRONMENT === "DEV") console.log("Dock: attach clicked");
  }, []);

  const handleTypeClick = useCallback(() => {
    // AnimatedDockContainer handles the type transition internally
  }, []);

  return {
    handleNoteClick,
    handleAttachClick,
    handleTypeClick,
  };
};
